module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/brand-page/brand-page.component.css
// module id = ./src/app/pages/brand-page/brand-page.component.css
// module chunks = main